import Vue from 'vue'
import VueAxios from 'vue-axios'

import axios from './axios'

Vue.use(VueAxios, axios)



// WEBPACK FOOTER //
// ./src/backend/Vue-axios/index.js